import {BellIcon, BellSlashIcon} from '@primer/octicons-react'
import {IconButton, Tooltip} from '@primer/react'
import {useCallback, useState} from 'react'
import {useRelayEnvironment} from 'react-relay'

import {LABELS} from '../../constants'
import {commitUpdateIssueSubscriptionMutation} from '../../mutations/update-issue-subscription'

type NotificationToggleButtonProps = {
  id: string
  subscribed: boolean
}

export function NotificationToggleButton({id, subscribed}: NotificationToggleButtonProps) {
  const icon = subscribed ? BellIcon : BellSlashIcon

  const environment = useRelayEnvironment()
  const [tooltip, setTooltip] = useState(getLabel(subscribed))

  const toggleSubscription = useCallback(() => {
    const newSubscribed = !subscribed
    commitUpdateIssueSubscriptionMutation({
      environment,
      input: {
        subscribableId: id,
        state: newSubscribed ? 'SUBSCRIBED' : 'UNSUBSCRIBED',
      },
      onCompleted: () => {
        setTooltip(newSubscribed ? LABELS.notifications.subscribedTooltip : LABELS.notifications.unsubscribedTooltip)
        setTimeout(() => {
          setTooltip(getLabel(newSubscribed))
        }, 2000)
      },
    })
  }, [environment, id, subscribed])

  return (
    <Tooltip aria-label={tooltip} direction="s">
      <IconButton onClick={toggleSubscription} variant="invisible" icon={icon} aria-label={tooltip} />
    </Tooltip>
  )
}

function getLabel(subscribed: boolean) {
  return subscribed ? LABELS.notifications.subscribedDescription : LABELS.notifications.unsubscribedDescription
}

try{ NotificationToggleButton.displayName ||= 'NotificationToggleButton' } catch {}